<template>
  <b-modal
    :id="id"
    centered
    hide-header
    hide-footer
    no-enforce-focus
    no-close-on-backdrop
    @show="reset"
  >
    <b-form
      @submit.prevent="onSubmit"
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 1rem
      "
    >
      <h2 class="mt-3">加入 YouTube 影片</h2>
      <ValidationObserver ref="form" class="w-100">
        <AGCLabel required>ID</AGCLabel>
        <br/>
        <div style="
          display: flex;
          flex-wrap: wrap;
          align-items: center;
        ">
          <span style="
            letter-spacing: -0.05rem;
            color: #00000088;
          ">
            https://www.youtube.com/watch?v=
          </span>
          <AGCInput
            v-model.trim="idInput"
            name="ID"
            style="
              margin: 0;
              flex: 1;
              flex-basis: 6rem;
            "
            rules="required|max:50"
            autofocus
          ></AGCInput>
        </div>
      </ValidationObserver>
      <p
        class="my-3"
        style="
          align-self: flex-start;
          color: #00000088;
        "
      >
        <span style="user-select: none">ⓘ&nbsp;</span>影片將以 16:9 比例顯示
      </p>
      <div
        style="
          width: 100%;
          display: flex;
          gap: 1.5rem;
        "
        class="my-2"
      >
        <b-button
          @click="$bvModal.hide(id)"
          variant="outline-primary"
          style="flex: 1"
        >
          取消
        </b-button>
        <b-button
          type="submit"
          variant="primary"
          style="flex: 1"
        >
          確認
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import AGCInput from '@/components/form/AGCInput.vue';
import AGCLabel from '@/components/form/AGCLabel.vue';
import formMixin from '@/mixins/form';
import { BButton, BForm } from 'bootstrap-vue';

export default {
  mixins: [formMixin],
  components: {
    AGCInput,
    AGCLabel,
    BButton,
    BForm,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    htmlCallback: {
      type: Function,
    },
  },
  data: () => ({
    idInput: '',
  }),
  computed: {
    generatedHTML() {
      return `<iframe
        width="100%"
        style="aspect-ratio: 16 / 9"
        src="https://www.youtube-nocookie.com/embed/${this.idInput}"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe><br/><br/>`;
    },
  },
  methods: {
    reset() {
      this.idInput = '';
    },
    async onSubmit() {
      if ((await this.validate().toPromise()) === undefined) {
        return;
      }
      this.htmlCallback(this.generatedHTML);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .form-group {
    margin: 0;
  }
  .form-control {
    padding: 0;
  }
}
</style>
